import { PlanungPermissionChecker } from '@bp/shared-planung-utils';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

type ProtectedOutletProps = {
  isAllowed: (permissionChecker: PlanungPermissionChecker | null) => boolean;
  redirect?: string;
};

export const ProtectedOutlet: FC<ProtectedOutletProps> = ({ isAllowed, redirect }) => {
  const perms = usePermissionChecker();

  if (isAllowed(perms)) {
    return <Outlet />;
  }

  if (redirect) {
    return <Navigate to={redirect} />;
  }

  return <>Permission Denied</>;
};
